var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwarenessActions, PlayAwarenessActions } from '../actions/index';
export var initialState = {
    play: null,
    playID: '',
    basin: '',
    element: '',
    riskMeanOEBXOM: '',
    discoveredVolumeIHS: '',
    closureCountXOM: '',
    closureCountIHS: '',
    fieldCountIHS: '',
    wellPenetrationCountIHS: '',
    summaryCharts: [],
    minAge: null,
    maxAge: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case PlayAwarenessActions.PlayAwarenessActions.SetPlay: {
            return __assign({}, state, { play: action.payload });
        }
        case PlayAwarenessActions.PlayAwarenessActions.SetPlayElement: {
            return __assign({}, state, { element: action.payload });
        }
        case PlayAwarenessActions.PlayAwarenessActions.LoadPlaySummarySuccess: {
            return __assign({}, state, action.playSummary);
        }
        case PlayAwarenessActions.PlayAwarenessActions.LoadDiscoveredVolumeSuccess: {
            return __assign({}, state, { discoveredVolumeIHS: action.payload });
        }
        case PlayAwarenessActions.PlayAwarenessActions.LoadDiscoveredVolumeFailure: {
            return __assign({}, state, { discoveredVolumeIHS: '-1' });
        }
        case PlayAwarenessActions.PlayAwarenessActions.SetSummaryCharts: {
            return __assign({}, state, { summaryCharts: action.payload });
        }
        case PlayAwarenessActions.PlayAwarenessActions.ClearPlaySummary: {
            return __assign({}, state, { playID: '', element: '', riskMeanOEBXOM: '', discoveredVolumeIHS: '', closureCountXOM: '', closureCountIHS: '', fieldCountIHS: '', wellPenetrationCountIHS: '', summaryCharts: [], minAge: null, maxAge: null });
        }
        case AwarenessActions.AwarenessActions.SetBasin: {
            if (action.payload === state.basin) {
                return state;
            }
            return __assign({}, state, { play: null, playID: '', element: '', basin: action.payload, riskMeanOEBXOM: '', discoveredVolumeIHS: '', closureCountXOM: '', closureCountIHS: '', fieldCountIHS: '', wellPenetrationCountIHS: '', summaryCharts: [], minAge: null, maxAge: null });
        }
        default: {
            return state;
        }
    }
}
